import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { addUser, fetchUsers, saveUserDetails, selectUser, deleteUser } from '../../reduxActions/UsersActions';

const UsersContext = React.createContext({});

class UsersStore extends React.Component {

    state = {
        searchText: '',
        rolefilter: null,
        rolefilteredUsers: null,
        filteredUsers: null,
        addingUser: false,
        editingUserDetails: false,
        shouldShowDeleteUserDialog: false
    };

    componentDidMount() {
        // Only fetch if data doesn't exist
        if (!this.props.users.users) {
            this.props.fetchUsers();
        }
    }

    updateSearchText = searchText => {
        let filteredUsersTemp = [];
        if (this.state.rolefilter) {
            filteredUsersTemp = searchText ? _.filter(this.state.rolefilteredUsers, user => `${user.displayName} ${user.bun}`.toUpperCase().includes(searchText.toUpperCase())) : this.state.rolefilteredUsers;
        } else {
            filteredUsersTemp = searchText ? _.filter(this.props.users.users, user => `${user.displayName} ${user.bun}`.toUpperCase().includes(searchText.toUpperCase())) : this.props.users.users;
        }

        this.setState({ searchText, filteredUsers: filteredUsersTemp })
    }

    updateRoleFilter = selectedRole => {
        let filteredUsers = [];

        if (selectedRole) {

            const result = this.props.users.usersRole.filter((userRole) => {
                return userRole.name.toUpperCase() == selectedRole.label.toUpperCase() && userRole.hasRole == true
            })

            this.props.users.users.map((user) => {
                const temp = result.filter((userRole) => {
                    return userRole.userId == user.id
                })

                if (temp.length) {
                    filteredUsers.push(user);
                }
            })

        } else {
            filteredUsers = this.props.users.users
        }

        this.setState({ rolefilter: selectedRole, rolefilteredUsers: filteredUsers, filteredUsers, searchText: '' })
    }

    updateAddingUser = addingUser => {
        console.log(addingUser);
        if (addingUser) {
            this.setState({ addingUser, searchText: '', rolefilter: null, rolefilteredUsers: null, filteredUsers: null });
        } else {
            this.setState({ addingUser });
        }
    };
    editUserDetails = () => this.setState({ editingUserDetails: true });
    cancelEditingUserDetails = () => this.setState({ editingUserDetails: false });
    showDeleteUserDialog = () => this.setState({ shouldShowDeleteUserDialog: true });
    hideDeleteUserDialog = () => this.setState({ shouldShowDeleteUserDialog: false });

    render() {

        return (

            <UsersContext.Provider
                value={
                    {
                        ...this.state,
                        ...this.props,
                        updateAddingUser: this.updateAddingUser,
                        updateSearchText: this.updateSearchText,
                        updateRoleFilter: this.updateRoleFilter,
                        editUserDetails: this.editUserDetails,
                        cancelEditingUserDetails: this.cancelEditingUserDetails,
                        showDeleteUserDialog: this.showDeleteUserDialog,
                        hideDeleteUserDialog: this.hideDeleteUserDialog


                    }
                }>
                {this.props.children}
            </UsersContext.Provider>

        );
    }
}

const mapStateToProps = state => {
    return {
        contentHeight: state.app.contentSize.height, users: state.users, aboutCurrentUser: state.app.aboutCurrentUser
    };
}

UsersStore = connect(mapStateToProps, { fetchUsers, selectUser, addUser, saveUserDetails, deleteUser })(UsersStore);

export { UsersStore };

export default UsersContext;